import { render, staticRenderFns } from "./FAQResetStamp.vue?vue&type=template&id=691bfbe2&scoped=true"
import script from "./FAQResetStamp.vue?vue&type=script&lang=js"
export * from "./FAQResetStamp.vue?vue&type=script&lang=js"
import style0 from "./FAQResetStamp.vue?vue&type=style&index=0&id=691bfbe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691bfbe2",
  null
  
)

export default component.exports